import { u as useLocalConfig } from "../../../composables/useLocalConfig.js";
import { computed } from "vue";
import { i as injectChildPresetPropFromParent } from "../../../composables/useChildComponents.js";
import { u as useGlobalConfig } from "../../../composables/useGlobalConfig.js";
const useComponentConfigProps = (component, originalProps) => {
  const localConfig = useLocalConfig();
  const { globalConfig } = useGlobalConfig();
  const instancePreset = computed(() => originalProps.preset);
  const getPresetProps = (presetName) => {
    var _a, _b, _c;
    return (_c = (_b = (_a = globalConfig.value.components) == null ? void 0 : _a.presets) == null ? void 0 : _b[component.name]) == null ? void 0 : _c[presetName];
  };
  const parentPropPreset = injectChildPresetPropFromParent();
  return computed(() => {
    var _a, _b;
    const globalConfigProps = {
      ...(_a = globalConfig.value.components) == null ? void 0 : _a.all,
      ...(_b = globalConfig.value.components) == null ? void 0 : _b[component.name]
    };
    const localConfigProps = localConfig.value.reduce(
      (finalConfig, config) => config[component.name] ? { ...finalConfig, ...config[component.name] } : finalConfig,
      {}
    );
    const presetName = (parentPropPreset == null ? void 0 : parentPropPreset.value) || instancePreset.value || localConfigProps.preset || globalConfigProps.preset;
    const presetProps = presetName && getPresetProps(presetName);
    return { ...globalConfigProps, ...localConfigProps, ...presetProps };
  });
};
export {
  useComponentConfigProps as u
};
//# sourceMappingURL=use-component-config-props.js.map
